<template>
  <component
    :is="as"
    class="ui-button-icon-rounded"
    :disabled="disabled"
  >
    <slot></slot>
  </component>
</template>

<script lang="ts" setup>
type Props = {
  as?: string | object
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  as: 'button',
})
</script>

<style lang="scss">
@import '../styles/config';

.ui-button-icon-rounded {
  flex: 0 0 auto;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 2.25rem;
  height: 2.25rem;
  color: $black;
  border: 1px solid $black;
  border-radius: 50%;
  @include transition('color, background-color, border-color');

  svg {
    width: 1rem;
    height: 1rem;
  }

  &:hover {
    background-color: $black;
    color: $white;
  }

  &:disabled {
    color: $gray-300;
    border-color: $gray-300;
    pointer-events: none;
  }

  @include media-breakpoint-up(md) {
    width: 2.75rem;
    height: 2.75rem;

    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
}
</style>
